// Routes owned by the Resume module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const resumePaths = {
    talentPoolManager: '/resume',
    talentPoolCreate: '/resume/new',
    talentPoolDetail: '/resume/:id',
} as const
